import { push } from 'connected-react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { StatusScreen } from '~molecules';
import success from '~icons/statusIcons/success.svg';
import { useAppDispatch } from '~store';
export var RegisterSuccess = function (_a) {
    var _b, _c;
    var match = _a.match;
    var dispatch = useAppDispatch();
    var t = useTranslation('registration').t;
    var tc = useTranslation('common').t;
    var root = match.url;
    var location = useLocation();
    var subheader = t('status.link_was_sent', {
        email: (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.email,
    });
    var externalId = (_c = location === null || location === void 0 ? void 0 : location.state) === null || _c === void 0 ? void 0 : _c.externalId;
    var onSendLink = function () {
        dispatch(push({
            pathname: "".concat(root, "/email"),
            state: {
                userId: externalId,
            },
        }));
    };
    return (React.createElement(StatusScreen, { header: t('status.created'), subheader: subheader, logo: success, buttonLabel: tc('buttons.resend_email'), onClick: onSendLink }));
};
